<template>
    <va-edit-layout>
        <RefundEventShipmentItem-form
            :id="id"
            :title="title"
            :item="item"
        ></RefundEventShipmentItem-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
